import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { Button, Input, Modal, ReloadIcon } from '@beef/ui-kit';
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var CaptchaModal = /*#__PURE__*/memo(function (_ref) {
  var onClose = _ref.onClose,
    onClick = _ref.onClick,
    onSubmitCaptcha = _ref.onSubmitCaptcha,
    onChange = _ref.onChange,
    captchaSrc = _ref.captchaSrc,
    isDisabledCaptcha = _ref.isDisabledCaptcha,
    captchaValue = _ref.captchaValue,
    error = _ref.error;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    onClose: onClose,
    size: "s",
    "data-t-id": "components-CaptchaModal"
  }, /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-CaptchaModal"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title')
  }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B \u0441 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438"), /*#__PURE__*/React.createElement("div", {
    className: cn('wrap')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "captcha",
    className: cn('img'),
    src: captchaSrc
  }), /*#__PURE__*/React.createElement("button", {
    className: cn('button'),
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(ReloadIcon, {
    size: "m"
  }))), /*#__PURE__*/React.createElement(Input, {
    errorMessage: error,
    name: "captcha",
    onChange: onChange,
    placeholder: "\u0421\u0438\u043C\u0432\u043E\u043B\u044B \u0441 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438",
    value: captchaValue
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('btn-wrap')
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabledCaptcha || !captchaValue,
    onClick: onSubmitCaptcha
  }, "\u0414\u0430\u043B\u0435\u0435"))));
});
CaptchaModal.displayName = CaptchaModal.name;